import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { appTheme } from '../../styles/theme';
import {
  AuthInputShell,
  authInputStyles,
} from './authFieldStyles';

const InputWrap = styled(AuthInputShell)`
  position: relative;
`;

const Input = styled.input<{ $invalid?: boolean }>`
  ${authInputStyles}
  padding-right: 72px;
`;

const ToggleButton = styled.button`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: ${appTheme.mint};
  padding: 6px 10px;
  font-family: inherit;
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: ${appTheme.green};
  cursor: pointer;
  border-radius: ${appTheme.radiusSm};
  transition: background 0.15s ease, color 0.15s ease;

  &:hover {
    background: rgba(19, 78, 68, 0.14);
    color: ${appTheme.greenDark};
  }

  &:focus-visible {
    outline: 2px solid ${appTheme.green};
    outline-offset: 2px;
  }
`;

type PasswordInputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  $invalid?: boolean;
};

const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ $invalid, ...props }, ref) => {
    const { t } = useTranslation();
    const [visible, setVisible] = useState(false);

    return (
      <InputWrap $invalid={$invalid}>
        <Input
          {...props}
          ref={ref}
          $invalid={$invalid}
          type={visible ? 'text' : 'password'}
        />
        <ToggleButton
          type="button"
          onClick={() => setVisible((current) => !current)}
          aria-label={visible ? t('common.hidePassword') : t('common.showPassword')}
          aria-pressed={visible}
        >
          {visible ? t('common.hideShort') : t('common.showShort')}
        </ToggleButton>
      </InputWrap>
    );
  },
);

PasswordInput.displayName = 'PasswordInput';

export default PasswordInput;
